import { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import moment from "moment";

import "./styles.scss";

import Header from "components/organisms/header/index.jsx";
import Button from "components/atoms/button";
import FormContent from "components/organisms/formContent";
import FormActions from "components/molecules/formActions";
import FormCol from "components/molecules/formCol";
import FormFieldset from "components/molecules/formFieldset";
import ReviewInformationBlock from "components/molecules/reviewInformationBlock";
import CollapsableSelectList from "components/organisms/collapsableSelectList";
import CollapsableSelectListItem from "components/molecules/collapsableSelectListItem";
import ExplainedCheckbox from "components/molecules/explainedCheckbox";
import Loader from "components/atoms/loader";
import WizardProgress from "components/organisms/wizard/progress";
import { currency } from "helpers/format";
import serviceHelper from "helpers/service";
import * as planHelper from "helpers/maintenancePlan";
import validate from "../validate";
import { request } from "actions/shifts";
import { verifyAvailability } from "services/shift";

class Review extends Component {
  constructor(props = {}) {
    super(props);
    this.state = {
      available: undefined,
    };
  }

  getParameter(parameter) {
    if (!this.props.vehicle) {
      return;
    }

    const parameters = this.props.parameters[parameter + "s"],
      selected = this.props[parameter],
      vehicleIds = Object.keys(this.props.vehicle[parameter + "s"] || {}),
      vehicleParameterId = vehicleIds.length === 1 ? vehicleIds[0] : 0;

    const selectedParameter = parameters.filter(
      (parameter) =>
        (selected && parameter.id === selected.id) || parameter.id == vehicleParameterId
    );

    return selectedParameter.length > 0 ? selectedParameter[0].name : "";
  }

  getPrice(service) {
    const vehicleName = this.props.vehicle.name.toLowerCase();
    return currency(serviceHelper.price(service, { legacyService: this.props.legacy_service, vehicleName }));
  }

  submit(values) {
    this.props.request(serviceHelper.buildShiftRequestObject(values), this.props.brandId);
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.isRequesting && !this.props.shiftCode && nextProps.shiftCode) {
      this.props.success();
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (!this.props.isRequesting && !this.props.shiftCode && nextProps.shiftCode) {
      return false;
    }

    return true;
  }

  interval = undefined;
  verifyAvailability = () => {
    verifyAvailability(
      this.props.date,
      this.props.hour,
      this.props.advisor?.id,
      this.props.worker?.id,
      this.props.brandId,
      this.props.workshop?.id
    ).then((available) => {
      this.setState({ available });
    });
  }

  componentDidMount() {
    this.verifyAvailability();

    this.interval = setInterval(() => {
      this.verifyAvailability();
    }, 60000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const {
      advisor,
      vehicle,
      //engine,
      //transmission,
      //traction,
      services,
      license_plate,
      date,
      hour,
      personal_information,
      goToPage,
      //parameters,
      wants_dynamic_reception,
      //onSubmit,
      addons,
      handleSubmit,
      requesting,
      //shiftCode,
      errorRequesting,
      chassis,
      has_modifications,
      public_use,
      maintenance_plan_id,
      maintenancePlan,
      worker,
    } = this.props;

    const vehicleName = vehicle.name.toLowerCase();
    const partiallyBonified = !vehicleName.includes('vento') && !vehicleName.includes('tiguan');

    const momentDate = moment(date);

    return (
      <div className="review">
        <Header inFlow />
        <WizardProgress step="7" />
        <section className="stepContent">
          <div className="container">
            <div className="col">
              <h2>Revisa y confirma tu turno</h2>

              <form onSubmit={handleSubmit(this.submit.bind(this))}>
                {!requesting && !errorRequesting && (
                  <FormContent nomargins small>
                    {this.state.available === false && (
                      <ReviewInformationBlock
                        title="Día y Hora"
                        blockAction="Editar Turno"
                        onClick={() => goToPage(5)}
                      >
                        <p style={{ color: 'red', fontWeight: 'bold' }}>
                          Lamentablemente la fecha y hora seleccionada
                          {momentDate.format("dddd DD")} de {momentDate.format("MMMM")}. {hour} hs.
                          ya no están disponibles.
                        </p>
                        <p>
                          Por favor seleccioná un nuevo día y horario para tu turno. Te pedimos
                          disculpas por las molestias ocasionadas.
                        </p>
                        <FormActions>
                          <Button
                            type="button"
                            buttonText="Cambiar fecha y hora"
                            onClick={() => goToPage(5)}
                          />
                        </FormActions>
                      </ReviewInformationBlock>
                    )}

                    <div>
                      <ReviewInformationBlock
                        title="Servicios solicitados"
                        blockAction="Editar Servicios"
                        onClick={() => goToPage(3)}
                      >
                        {services &&
                          services.map((service, i) => {
                            if (!service) {
                              return null;
                            }

                            return (
                              <div key={i}>
                                <strong>{service.name}:</strong>
                                {service.bonified ? (
                                  <div className="price">
                                    {partiallyBonified ? (
                                      <>{this.getPrice(service)}**</>
                                    ) : (
                                      <>Precio bonificado*</>
                                    )}
                                  </div>
                                ) : (
                                  <div className="price">{this.getPrice(service)}</div>
                                )}
                              </div>
                            );
                          })}

                        {addons &&
                          addons.map((addon, i) => {
                            return (
                              <div key={i}>
                                <strong>Adicional: {addon.name}:</strong>
                                <div className="price">{this.getPrice(addon)}</div>
                              </div>
                            );
                          })}
                        {wants_dynamic_reception && <p>Solicita recepción dinámica </p>}
                      </ReviewInformationBlock>

                      {maintenance_plan_id > 0 && maintenancePlan && (
                        <ReviewInformationBlock
                          title="Contrato de mantenimiento"
                          blockAction="Editar elección"
                          onClick={() => goToPage(3)}
                        >
                          <div>Incluye los servicios:</div>
                          {maintenancePlan.services.map((service) => {
                            return (
                              <div key={service.id}>
                                <strong>{service.name}.</strong>
                              </div>
                            );
                          })}

                          <div>
                            <strong>Total a pagar:</strong>
                            <div className="price">
                              {currency(planHelper.getPrice(maintenancePlan))}
                            </div>
                          </div>
                          {maintenancePlan.installments && (
                            <div>en hasta {maintenancePlan.installments} cuotas.</div>
                          )}
                        </ReviewInformationBlock>
                      )}

                      <ReviewInformationBlock
                        capitalize
                        title="Día y Hora"
                        blockAction="Editar Turno"
                        onClick={() => goToPage(5)}
                      >
                        <p>
                          {momentDate.format("dddd DD")} de {momentDate.format("MMMM")}. {hour} hs.
                        </p>
                      </ReviewInformationBlock>
                      <ReviewInformationBlock
                        title="Tus datos"
                        blockAction="Editar Datos"
                        onClick={() => goToPage(8)}
                      >
                        {personal_information && personal_information.company && (
                          <p>
                            {personal_information.company}, CUIT: {personal_information.dni}.
                          </p>
                        )}
                        {personal_information && !personal_information.company && (
                          <p>
                            {personal_information.name} {personal_information.lastname}, DNI:{" "}
                            {personal_information.dni}.
                          </p>
                        )}

                        <p>
                          <strong>Domicilio: </strong>
                          {personal_information.address}.<br /> <strong>E-mail: </strong>
                          {personal_information.email}. <strong>Celular:</strong>{" "}
                          {personal_information.cellphone}
                        </p>
                      </ReviewInformationBlock>

                      <ReviewInformationBlock
                        title="Datos del vehículo"
                        blockAction="Editar Datos"
                        onClick={() => goToPage(1)}
                      >
                        <p>
                          {vehicle && vehicle.name}, {this.getParameter("traction")}{" "}
                          {this.getParameter("transmission")} {this.getParameter("engine")}.
                        </p>
                        <p>
                          <strong>Dominio:</strong> {license_plate}. <strong>Chasis:</strong>{" "}
                          {chassis}. <br />
                          {has_modifications
                            ? " Vehículo con modificaciones sobre el equipamiento de fábrica."
                            : " Sin modificaciones sobre el equipamiento de fábrica."}
                          <br />
                          {public_use
                            ? " Vehículo de uso comercial."
                            : "Vehículo de uso particular."}
                        </p>
                      </ReviewInformationBlock>

                      <ReviewInformationBlock
                        title="Asesor"
                        blockAction="Editar Asesor"
                        onClick={() => goToPage(7)}
                      >
                        {advisor && (
                          <p>
                            Serás atendido por {advisor.name} {advisor.lastname}.
                          </p>
                        )}
                        {worker && (
                          <p>
                            Serás atendido por {worker.name} {worker.lastname}.
                          </p>
                        )}
                      </ReviewInformationBlock>
                      {this.props.brandId === 1 && (
                        <ReviewInformationBlock type="info">
                          <p>
                            Traer tarjeta verde del vehículo y tuerca de seguridad (si corresponde).
                          </p>
                        </ReviewInformationBlock>
                      )}
                    </div>
                    <CollapsableSelectList>
                      <CollapsableSelectListItem>
                        <Field
                          component={ExplainedCheckbox}
                          name="requests_taxi"
                          props={{
                            title: "Necesito que me llamen un taxi.",
                            helpText: "Costo no incluído",
                            fieldValue: true,
                            toggleValue: false,
                          }}
                        />
                      </CollapsableSelectListItem>
                    </CollapsableSelectList>
                    <FormActions>
                      <Button
                        type="submit"
                        buttonText="Confirmar turno"
                        disabled={!this.state.available}
                      />
                    </FormActions>
                  </FormContent>
                )}
                {requesting && !errorRequesting && (
                  <FormContent small>
                    <br />
                    <Loader />
                    <h5>Estamos pidiendo tu turno.</h5>
                  </FormContent>
                )}
                {!requesting && errorRequesting && (
                  <FormContent small>
                    <FormCol single center>
                      <FormFieldset first>
                        <p>
                          Ocurrió un error solicitando tu turno. Por favor reiniciá este formulario
                          y verificá que las opciones seleccionadas sean correctas.
                        </p>
                        <p>
                          Si el problema persiste, por favor{" "}
                          <a href="http://www.territorioyacopini.com.ar">contactanos</a>.
                        </p>
                      </FormFieldset>
                    </FormCol>
                  </FormContent>
                )}
                <br />* Sujeto a confirmación.
                <br />** Consultar bonificación de serie
              </form>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

Review = reduxForm({
  form: "shiftRequest",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(Review);

const selector = formValueSelector("shiftRequest");

const mapDispatchToProps = (dispatch) => {
  return {
    request: (data, brandId) => {
      dispatch(request(data, brandId));
    },
  };
};

Review = connect((state) => {
  return {
    vehicle: selector(state, "vehicle"),
    engine: selector(state, "engine"),
    transmission: selector(state, "transmission"),
    traction: selector(state, "traction"),
    services: selector(state, "services"),
    has_modifications: selector(state, "has_modifications"),
    public_use: selector(state, "public_use"),
    chassis: selector(state, "chassis"),
    wants_dynamic_reception: selector(state, "wants_dynamic_reception"),
    hour: selector(state, "hour"),
    date: selector(state, "date"),
    advisor: selector(state, "advisor"),
    license_plate: selector(state, "license_plate"),
    legacy_service: selector(state, "legacy_service"),
    personal_information: selector(state, "personal_information"),
    addons: selector(state, "addons"),
    maintenance_plan_id: selector(state, "maintenance_plan_id"),
    parameters: state.models.parameters,
    requesting: state.shifts.isRequesting,
    shiftCode: state.shifts.code,
    errorRequesting: state.shifts.error,
    brandId: state.configuration.brand_id,
    maintenancePlan: state.maintenancePlans.available,
    workshop: selector(state, "workshop"),
    worker: selector(state, "worker"),
  };
}, mapDispatchToProps)(Review);

export default Review;
